import { render, staticRenderFns } from "./StockPurchaseTreeMap.vue?vue&type=template&id=64adf3c8"
import script from "./StockPurchaseTreeMap.vue?vue&type=script&lang=ts"
export * from "./StockPurchaseTreeMap.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports